import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteSystemLogs = (toDate: string) => {
  return axios.delete(`/api/system-logs/${toDate}`);
};

type UseDeleteSystemLogsOptions = {
  config?: MutationConfig<typeof deleteSystemLogs>;
};

export const useDeleteSystemLogs = ({ config }: UseDeleteSystemLogsOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['systemLogs']);
    },
    ...config,
    mutationFn: deleteSystemLogs,
  });
};
